module.exports = "//cdn.mxpnl.com/static/asset-cache/6b9d3e39edda596bfbff543012a60ba1/iron/common/assets/images/charts/line.svg";